import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {getMissingSize} from '../api/missingsizes.api';
import {productearch} from '../api/product-search.api';
import {CurrentProductInfo} from '../lib/missingsizesdata/missingsizesconstant';
import {missingSizeFunction} from '../lib/missingsizesdata/missingsizefunction';
interface stocks {
  stockLevel: number;
  stockLevelStatus: string;
}
interface variant2 {
  code: string;
  stock: stocks;
  hasSwatches: boolean;
  isSelected: boolean;
  size: string;
}
interface variant1 {
  code: string;
  stock: stocks;
  color: string;
  colorImageUrl: string;
  hasSwatches: boolean;
  isSelected: boolean;
  varianttype: string;
  variants: variant2[];
}

interface prices {
  currencyIso: string;
  formattedValue: string;
  priceType: string;
  value: number;
}
export interface missingSizeReturn {
  name: string;
  price: prices;
  url: string;
  variants: variant1[];
}
export interface productSearchData {
  result: boolean;
  resultCode: string;
  message: string;
  itemCode: string;
  eanNumber: string;
  size: string;
  color: string;
  base_product: string;
  base_product_1: string;
}

interface missingSizeState {
  users: missingSizeReturn;
  loading: boolean;
  error: string;
  productData: productSearchData;
  productLoading: boolean;
  productError: string;
  orderedProductInfo?: CurrentProductInfo;
}
const initialProductData = {
  result: false,
  resultCode: '',
  message: '',
  itemCode: '',
  eanNumber: '',
  size: '',
  color: '',
  base_product: '',
  base_product_1: '',
};

const initialData = {
  name: '',
  price: {
    currencyIso: '',
    formattedValue: '',
    priceType: '',
    value: 0,
  },
  url: '',
  variants: [
    {
      code: '',
      stock: {
        stockLevel: 0,
        stockLevelStatus: '',
      },
      color: '',
      colorImageUrl: '',
      hasSwatches: false,
      isSelected: false,
      varianttype: '',
      variants: [
        {
          code: '',
          stock: {
            stockLevel: 0,
            stockLevelStatus: '',
          },
          hasSwatches: false,
          isSelected: false,
          size: '',
        },
      ],
    },
  ],
};

//Define the initial state using that type
const initialState: missingSizeState = {
  users: initialData,
  loading: false,
  error: '',
  productData: initialProductData,
  productLoading: false,
  productError: '',
  orderedProductInfo: undefined,
};

export const missingSizeApiCall = createAsyncThunk(
  'missingsizessapi',
  async (parameters: any, thunkApi) => {
    return getMissingSize(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const productSearchApiCall = createAsyncThunk(
  'product/detailfetch',
  async (parameters: any, thunkApi) => {
    return productearch(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const missSizeApiSlice = createSlice({
  name: 'missingSizeapi',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    arrangeMissingSizeData: state => {
      state.orderedProductInfo = missingSizeFunction(
        state.users,
        state.productData,
      );
      //console.log(state.orderedProductInfo);
    },
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(missingSizeApiCall.pending, state => {
      state.loading = true;
    });
    builder.addCase(missingSizeApiCall.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
    });
    builder.addCase(missingSizeApiCall.rejected, (state, action) => {
      // console.log('action====>', action);
      state.error = action.toString();
      state.loading = false;
    });

    builder.addCase(productSearchApiCall.pending, state => {
      state.productLoading = true;
    });
    builder.addCase(productSearchApiCall.fulfilled, (state, action) => {
      state.productLoading = false;
      state.productData = action.payload;
    });
    builder.addCase(productSearchApiCall.rejected, (state, action) => {
      //console.log('action====>', action);
      state.productError = action.toString();
      state.productLoading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type

export const {arrangeMissingSizeData, resetState} = missSizeApiSlice.actions;

export const MissingSizeData = (state: RootState): missingSizeReturn =>
  state.missSizeApiSlice.users;
export const missingSizeOrderedInfo = (
  state: RootState,
): CurrentProductInfo | undefined => state.missSizeApiSlice.orderedProductInfo;
export const error = (state: RootState): string => state.missSizeApiSlice.error;
export const loading = (state: RootState): boolean =>
  state.missSizeApiSlice.loading;

export const productSizeData = (state: RootState): productSearchData =>
  state.missSizeApiSlice.productData;
export const productsearchError = (state: RootState): string =>
  state.missSizeApiSlice.productError;
export const productIsLoading = (state: RootState): boolean =>
  state.missSizeApiSlice.productLoading;

export default missSizeApiSlice.reducer;
